export const auth0Config = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  authorizationParams: {
    // Fixed callback path (matches the *.centerbase.ai Auth0 wildcard). Works on
    // subdomain hosts and the shared host alike — the tenant is not in the URL.
    redirect_uri: `${window.location.origin}/ssocallback`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: 'openid profile email offline_access',
  },
  cacheLocation: 'localstorage',
  useRefreshTokens: true,
}

export const validateAuth0Config = () => {
  const required = [
    { key: 'VITE_AUTH0_DOMAIN', value: import.meta.env.VITE_AUTH0_DOMAIN },
    { key: 'VITE_AUTH0_CLIENT_ID', value: import.meta.env.VITE_AUTH0_CLIENT_ID },
    { key: 'VITE_AUTH0_AUDIENCE', value: import.meta.env.VITE_AUTH0_AUDIENCE },
  ]

  const missing = required.filter(({ value }) => !value)
  if (missing.length > 0) {
    const keys = missing.map(({ key }) => key).join(', ')
    throw new Error(`Missing required Auth0 configuration: ${keys}. Check your .env file.`)
  }
}
